const breadCrumb = "Diário Digital";

const routes = [
  {
    path: "/habilitar-uso-diario-digital-ensino",
    name: "habilitar-uso-diario-digital-ensino",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/HabilitarUsoDiarioDigitalEnsino/HabilitarUsoDiarioDigitalEnsinoHome.vue"
      ),
  },
  {
    path: "/habilitar-uso-diario-digital-ensino-cadastro",
    name: "habilitar-uso-diario-digital-ensino-cadastro",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/HabilitarUsoDiarioDigitalEnsino/HabilitarUsoDiarioDigitalEnsinoCad.vue"
      ),
  },
  {
    path: "/habilitar-uso-diario-digital-ensino-editar/:id",
    name: "habilitar-uso-diario-digital-ensino-editar",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/HabilitarUsoDiarioDigitalEnsino/HabilitarUsoDiarioDigitalEnsinoEdit.vue"
      ),
  },
];

export default routes;
